// @flow
import React,{Fragment} from 'react'
import {connect} from 'react-redux'
import FaqId from '../partials/FaqId'
import FaqEn from '../partials/FaqEn'
import { Link } from 'react-router-dom'
import Footer from '../partials/Footer.jsx'
import ModalVideoFaq from'../partials/ModalVideoFaq'
import $ from 'jquery'

function getAllUrlParams(url) {

  // get query string from url (optional) or window
  var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

  // we'll store the parameters here
  var obj = {};

  // if query string exists
  if (queryString) {

    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split('#')[0];

    // split our query string into its component parts
    var arr = queryString.split('&');

    for (var i = 0; i < arr.length; i++) {
      // separate the keys and the values
      var a = arr[i].split('=');

      // set parameter name and value (use 'true' if empty)
      var paramName = a[0];
      var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

      // (optional) keep case consistent
      paramName = paramName.toLowerCase();
      if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

      // if the paramName ends with square brackets, e.g. colors[] or colors[2]
      if (paramName.match(/\[(\d+)?\]$/)) {

        // create key if it doesn't exist
        var key = paramName.replace(/\[(\d+)?\]/, '');
        if (!obj[key]) obj[key] = [];

        // if it's an indexed array e.g. colors[2]
        if (paramName.match(/\[\d+\]$/)) {
          // get the index value and add the entry at the appropriate position
          var index = /\[(\d+)\]/.exec(paramName)[1];
          obj[key][index] = paramValue;
        } else {
          // otherwise add the value to the end of the array
          obj[key].push(paramValue);
        }
      } else {
        // we're dealing with a string
        if (!obj[paramName]) {
          // if it doesn't exist, create property
          obj[paramName] = paramValue;
        } else if (obj[paramName] && typeof obj[paramName] === 'string'){
          // if property does exist and it's a string, convert it to an array
          obj[paramName] = [obj[paramName]];
          obj[paramName].push(paramValue);
        } else {
          // otherwise add the property
          obj[paramName].push(paramValue);
        }
      }
    }
  }

  return obj;
}

class FrequentlyAskedQuestion extends React.Component<Props>{
    constructor(props) {
		super(props)

	}

    componentDidMount() {
		window.scrollTo(0, 0)
    $('#public').attr('id','not-public')
	}

  componentWillUnmount(){
    $('#not-public').attr('id','public')
  }

    render(){
        const {langId} = this.props
        const videoParams=getAllUrlParams().watchvideo
        return(
            <Fragment>
             <header id="headerSection" className="headContainerWhite">
                <div className="container">
                    <div className="sticky-nav header">
                    <nav className="navbar">
                        <div className="container-fluid">
                        <div className="navbar-header navbar-faq-left">
                            <Link className="navbar-brand" to={`/`}>ASTRNT</Link>
                        </div>
                        <ul class="nav navbar-nav navbar-right navbar-faq-right">
                         <li class="lang-switcher">
                      {langId == "en"|| langId === undefined ? 
                      <Fragment>
                      <Link to={`/faq/en`} className="active">EN</Link>|<Link to={`/faq/id`}>ID</Link>
                      </Fragment>
                       : 
                       <Fragment>
                         <Link to={`/faq/en`}>EN</Link>|<Link to={`/faq/id`} className="active">ID</Link>
                          </Fragment>
                      }
                         </li>
                       </ul> 
                           
                        </div>
                    </nav>
                    </div>
                </div>
            </header>
             {langId == "en" || langId === undefined   ? 
                  <FaqEn/>
             :
           
          
             <FaqId/>
             }
            <Footer/>
            {
              videoParams ? <ModalVideoFaq onRef={ref => (this.ModalWelcomeVideo = ref)}/> :null
            }
            
            </Fragment>

        )
    }
}

const mapStateToProps = (state, ownProps) => {
	return {
		langId: ownProps.match.params.langId
	}
}


export default connect(mapStateToProps, null)(FrequentlyAskedQuestion)